import type { ValidChainId, } from "@types";
export const ValidChainIds:Array<ValidChainId> = [1,42161];
